import { getAuthenticatedFetch } from "../../msal/authenticatedFetchService";

class EnvironmentTemplateService {
    async getEnvironmentTemplates() {
        let url = `${process.env.REACT_APP_SELF_SERVICE_PEOPLEPLANNER_API_URL}/EnvironmentTemplate/`;
        let response = await getAuthenticatedFetch()(url);
        return await response.json();
    }
}

export default new EnvironmentTemplateService();
